import { useIntl } from '@weenat/wintl';
import { DeviceBroadcastNetwork } from '../../enums/Devices';
export const useBrodcastNetworkName = ({ device }) => {
    const { t } = useIntl();
    const { broadcastNetwork } = device;
    switch (broadcastNetwork) {
        case DeviceBroadcastNetwork.SIGFOX:
            return t('models.device.broadcast_networks.sigfox');
        case DeviceBroadcastNetwork.LoRa:
            return t('models.device.broadcast_networks.lora');
        case DeviceBroadcastNetwork.CELLULAR:
            return t('models.device.broadcast_networks.cellular');
    }
};
